import { getSelectedProjectId } from 'owa-timestream-store';
import getDefaultBoardProject from './getDefaultBoardProject';

export default function isDefaultBoardProjectOpen(): boolean {
    try {
        const defaultProject = getDefaultBoardProject();
        return !!defaultProject && defaultProject.projectId === getSelectedProjectId();
    } catch {
        return false;
    }
}
